<template>
  <div id="OrderDetails">
    <div class="header2">
      <div class="header2Wrap">
        <div class="header2L">
          <img src="@/assets/list/logo.png" alt />
        </div>
      </div>
    </div>
    <!-- 主体 -->
    <div class="main">
      <h3>订单详情</h3>
      <div class="content">
        <div class="add">
          <p class="add1">收货地址：</p>
          <p class="add2">{{ dataList.atShdz }}（{{ dataList.atYhmc }}收）{{ dataList.atLxfs }}</p>
          <!-- <span class="default">默认地址</span> -->
        </div>
        <div class="add SellerInfo" v-show="false">
          <p><b>【卖家信息】</b></p>
          <p>卖家名称：畅通圆</p>
        </div>
        <div class="add OrderInfo">
          <p><b>【订单信息】</b></p>
          <p class="OrderInfoTxt">
            <span>订单编号：{{ dataList.id }} &nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span v-if="dataList.spZfgl"> 支付单号：{{ dataList.spZfgl }} &nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>创建时间：{{ dataList.createDate }}</span>
          </p>
        </div>
        <ul class="Tabtit">
          <li class="Tabtit1 width1">商品信息</li>
          <li class="Tabtit1 width2">订单状态</li>
          <li class="Tabtit1 width3">单价</li>
          <li class="Tabtit1 width3">单位</li>
          <li class="Tabtit1 width4">数量</li>
          <li class="Tabtit1 width5">优惠类型</li>
          <li class="Tabtit1 width6">商品小计</li>
        </ul>
        <div class="lists" v-for="(item, index) in dataList.ddmxList" :key="index">
          <div class="lists1 width1">
            <div class="imgs">
              <img :src="$store.state.imgUrl + item.atPhotoUrl" alt />
            </div>
            <p>{{ item.atSpmc }} - {{ item.standard }}</p>
            <!-- <p @click="goDetail(item.spSpgl)">{{item.atSpmc}}</p> -->
          </div>
          <p class="lists1 width2">{{ dataList.optDdzt }}</p>
          <div class="width3">
            <!-- ￥{{ item.atYpdj }} -->
            <div class='money' v-if="item.optYhlx!=3">
							<p class="money1">
								￥{{item.atSpje}}
							</p>
							<p class="money2">
								￥{{item.atYjje}}
							</p>
						</div>
					 	<div class='money' v-if="item.optYhlx==3">
							<p class="money1">
								￥{{item.atYjje}}
							</p>
						</div>
          </div>
          <p class="lists1 width3">{{ item.unit }}{{ item.unitByDefault ? '(' + item.unitByDefault + ')' : '' }}</p>
          <p class="lists1 width4">{{ item.atSpsl }}</p>
          <div class="lists5 width5">
            <div class="li2-l">
							<div class="p-li3" v-show="item.optYhlx==1">{{item.atZkbl}}折优惠</div>
							<div class="p-li3" v-show="item.optYhlx==2">团购</div>
							<div class="p-li3" v-show="item.optYhlx==4">批发</div>
							<div class="p-li3" v-show="item.optYhlx==5">批发商</div>
              <div class="p-li3" v-show="item.optYhlx==3">暂无优惠</div>
						</div>
          </div>
          <div class="lists1 width6">
            ￥{{ item.atSpzje}}
          </div>
        </div>
        <div class="sums">
          <div class="sumLi">
            <span>商品总额：</span>
            <span>￥{{ dataList.atYpSpZje }}</span>
          </div>
          <div class="sumLi">
            <span>商品优惠：</span>
            <span>-￥{{ dataList.atYhje }}</span>
          </div>
          <div class="sumLi">
            <span>运费：</span>
            <span>￥{{ dataList.atYfje }}</span>
          </div>
        </div>

        <div class="sum">
          <span>支付金额：</span>
          <span>￥{{ dataList.atSpzje }}</span>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "OrderDetails",
  data() {
    return {
      dataList: [],
      userId: "",
      AddressList1: {},//默认地址
    };
  },
  components: {
  },
  created() {
    if (sessionStorage.getItem("userInfo")) {
      this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      this.userId = this.userInfo.id;
    }
    this.getData();
    // this.getAddress();
  },
  methods: {
    getData() {
      var params = {};
      params.id = this.$route.query.id;
      params.createBy = this.userId;
      let url = "/ddgl/getAppIndexListDetailV2";
      this.$http.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.dataList = res.data.data;
          switch (this.dataList.optDdzt) {
            case 0:
              this.dataList.optDdzt = "待付款";
              break;
            case 1:
              this.dataList.optDdzt = "已取消";
              break;
            case 3:
              this.dataList.optDdzt = "付款成功（待发货）";
              break;
            case 4:
              this.dataList.optDdzt = "待收货";
              break;
            case 5:
              this.dataList.optDdzt = "已收货（待评价）";
              break;
            case 6:
              this.dataList.optDdzt = "退单中";
              break;
            case 7:
              this.dataList.optDdzt = "退单成功";
              break;
            case 9:
              this.dataList.optDdzt = "已开发票";
              break;
            case 10:
              this.dataList.optDdzt = "已完成";
              break;
            case 11:
              this.dataList.optDdzt = "待回复";
              break;
            case 12:
              this.dataList.optDdzt = "待用户确认";
              break;
            case 14:
              this.dataList.optDdzt = "部分退款";
              break;
            default: this.dataList.optDdzt = "未知状态";
          }

          this.dataList.createDate = this.getTime(this.dataList.createDate)

        }
      });
    },
    //    getAddress() {
    //   //获取地址
    //   var params = {};
    //   params.createBy = this.userId;
    //   let url = "/dzgl/getList";
    //   this.$http.post(url, params).then(res => {
    //     if (res.data.code == 200) {
    //       var list = res.data.data.list;
    //        this.AddressList1 = list[0];

    //     }
    //   });
    // },
    goDetail(id) {//跳转商品详情
      if (id) {
        this.$router.push({ path: '/ProductDetails/' + id })
      } else {
        return
      }

    }
  }
};
</script>
<style scoped>
.main {
  max-width: 1440px;
  max-width: 80%;
  width: 1024px;
  height: 1000px;
  margin: 0px auto;
}

.header2 {
  width: 100%;
  height: 94px;
  background-color: #f64420;
}

.header2Wrap {
  max-width: 1440px;
  max-width: 80%;
  width: 1024px;
  height: 100%;
  margin: 0px auto;
}

.header2L {
  float: left;
  width: 280px;
  height: 80%;
  margin-top: 10px;
}

.header2L img {
  width: 100%;
  height: 100%;
}

.content {
  width: 100%;
}

.content::after {
  content: "";
  height: 0;
  clear: both;
  overflow: hidden;
  display: block;
  visibility: hidden;
}

.add {
  width: 100%;
  height: 56px;
  background-color: #ffffff;
  border: dashed 1px #dddddd;
  box-sizing: border-box;
  padding: 10px;
}

.add p {
  float: left;
  line-height: 36px;
}

.add .add1 {
  height: 36px;
  font-weight: 600;
  width: 80px;
}

.add .add2 {
  width: 800px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.add .default {
  float: left;
  display: block;
  width: 66px;
  height: 20px;
  background-color: #f64420;
  border-radius: 10px;
  font-size: 12px;
  text-align: center;
  line-height: 20px;
  letter-spacing: 1px;
  color: #ffffff;
  margin-top: 9px;
}

.add .add3 {
  float: right;
  cursor: pointer;
}

.SellerInfo,
.OrderInfo {
  height: 40px;
  line-height: 40px;
  padding-top: 0;
  padding-left: 0;
  padding-bottom: 0;
}

.OrderInfoTxt {
  font-size: 13px;
}

.block {
  width: 85%;
  margin: 20px auto;
}

.Tabtit {
  width: 100%;
  height: 47px;
  background-color: #f0f0f0;
  border: solid 1px #dddddd;
  box-sizing: border-box;
  padding: 10px;
  margin-top: 20px;
}

.Tabtit li {
  float: left;
  height: 27px;
  line-height: 27px;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  letter-spacing: 1px;
  color: #333333;
}

.width1 {
  width: 30%;
}

.width2 {
  width: 15%;
  text-align: center;
}

.width3 {
  width: 10%;
  text-align: left;
  display: flex;
  align-items: center;
  justify-items:self-start;
  height: 98px;
  float: left;
}
.width3 p{
  width: 100%!important;
  height: 20px!important;
  line-height: 20px;
}
.width3 .money1{
  color: #f64420;
  font-weight: bold;
  font-size: 16px;
}
.width3 .money2{
  color: #999;
  font-size: 16px;
  text-decoration: line-through;
}
.width4 {
  width: 8%;
  text-align: center;
}

.width5 {
  width: 15%;
  text-align: center;

}

.width5 .p-li3 {
  margin-top: 35px !important;
}

.width6 {
  width: 10%;
  text-align: center;
}

.lists {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 30px;
  height: 118px;
  background-color: #ffffff;
  border: solid 1px #dddddd;
}

.lists1,
.list2,
.list3,
.list4 {
  height: 98px;
  float: left;
  line-height: 98px;
}

.lists1 .imgs {
  height: 88px;
  width: 116px;
  float: left;
  overflow: hidden;
  /* cursor: pointer; */
}

.lists1 .imgs img {
  width: 100%;
  min-height: 100%;
}

.lists1 p {
  float: left;
  height: 88px;
  width: 153px;
  line-height: 30px;
  margin-left: 10px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  /* cursor: pointer; */
}

.lists1 p:hover {
  /* color:#f64420; */
}

.lists5 {
  height: 98px;
  float: left;
}

.lists5.active1 {
  color: #61baf6;
}

.lists5.active2 {
  color: #f6441e;
}

.lists5 p:nth-child(1) {
  margin-top: 20px;
}

.lists5 p {
  height: 30px;
  line-height: 30px;
}

.counts {
  width: 100%;
  height: 123px;
  background-color: #ffffff;
  border: solid 1px #dddddd;
  margin-top: 20px;
  box-sizing: border-box;
  padding: 10px 30px;
}

.countsL {
  float: left;
  width: 60%;
}

.countsL span {
  display: block;
  float: left;
}

.countsL input {
  float: left;
}

.countsR {
  float: right;
  width: 20%;
  margin-top: 0px;
}
.sums {
  margin-top: 20px;
  background: #fff;
  border: 1px solid #ddd;
  text-align: right;
  box-sizing: border-box;
  padding: 10px;
 
}

.sumLi{
  display: flex;
  width: 100%;
  justify-content: flex-end;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
}
.sums span:nth-child(2) {
  min-width: 60px;
  color: #f64420;
  font-size: 18px;
}
.sum {
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-top: 20px;
  width: 100%;
  height: 40px;
  line-height: 20px;
  font-size: 14px;
  background: #fff;
  border: 1px solid #ddd;
  text-align: right;
  box-sizing: border-box;
  padding: 10px;
}

.sum span:nth-child(2) {
  min-width: 60px;
  color: #f64420;
  font-size: 18px;
}
</style>


// WEBPACK FOOTER //
// src/components/ShoppingMall/OrderDetails.vue